import { TRANSLATION } from '../localization'

export const months = [
  { id: 1, name: TRANSLATION.JANUARY },
  { id: 2, name: TRANSLATION.FEBRUARY },
  { id: 3, name: TRANSLATION.MARCH },
  { id: 4, name: TRANSLATION.APRIL },
  { id: 5, name: TRANSLATION.MAY },
  { id: 6, name: TRANSLATION.JUNE },
  { id: 7, name: TRANSLATION.JULY },
  { id: 8, name: TRANSLATION.AUGUST },
  { id: 9, name: TRANSLATION.SEPTEMBER },
  { id: 10, name: TRANSLATION.OCTOBER },
  { id: 11, name: TRANSLATION.NOVEMBER },
  { id: 12, name: TRANSLATION.DECEMBER },
]

export const years = [
  { id: 1, name: '2019' },
  { id: 2, name: '2021' },
  { id: 3, name: '2022' },
  { id: 4, name: '2023' },
  { id: 5, name: '2024' },
  { id: 6, name: '2025' },
]